import { IQuarterlyPartnerTableRow } from 'partner360/models/report/sobAnalyticsReports/iQuarterlyPartnerTableRow'

import { IQuarterlyPartnerItem } from '../../../model/types/pptxExport/quarterly/IQuarterlyPartnerItem'

export const mapQuarterlyPartnerData = (
  data: IQuarterlyPartnerTableRow[]
): IQuarterlyPartnerItem[] => {
  return data.map((item) => ({
    itemId: item.itemId,
    countryCode: item.countryCode ?? null,
    title: item.title,
    geoMarket: item.geoMarket ?? null,
    offering: item.offering ?? null,
    order: item.order,
    parentId: null,

    prevYearActualsRevenue: item.prevYearActualsRevenue,
    prevYearActualsRevenueNet: item.prevYearActualsRevenueNet,
    prevYearActualsRevenueTNet: item.prevYearActualsRevenueTNet,
    prevYearActualsRevenueUTNet: item.prevYearActualsRevenueUTNet,
    prevYearEstimatedActualsRevenue: item.prevYearEstimatedActualsRevenue,
    prevYearEstimatedActualsRevenueNet: item.prevYearEstimatedActualsRevenueNet,
    prevYearEstimatedActualsRevenueTNet: item.prevYearEstimatedActualsRevenueTNet,
    prevYearEstimatedActualsRevenueUTNet: item.prevYearEstimatedActualsRevenueUTNet,
    prevYearSobActual: item.prevYearSobActual,
    prevYearSobActualNet: item.prevYearSobActualNet,
    prevYearSobActualTNet: item.prevYearSobActualTNet,
    prevYearSobActualUTNet: item.prevYearSobActualUTNet,
    prevYearYoYPP: item.prevYearYoYPP,
    prevYearYoYPPNet: item.prevYearYoYPPNet,
    prevYearYoYPPTNet: item.prevYearYoYPPTNet,
    prevYearYoYPPUTNet: item.prevYearYoYPPUTNet,
    prevYearVsPlan: item.prevYearVsPlan,
    prevYearVsPlanNet: item.prevYearVsPlanNet,
    prevYearVsPlanTNet: item.prevYearVsPlanTNet,
    prevYearVsPlanUTNet: item.prevYearVsPlanUTNet,
    prevYearQuarterTamActuals: item.prevYearQuarterTamActuals,
    prevYearQuarterTamActualsNet: item.prevYearQuarterTamActualsNet,
    prevYearQuarterTamActualsTNet: item.prevYearQuarterTamActualsTNet,
    prevYearQuarterTamActualsUTNet: item.prevYearQuarterTamActualsUTNet,

    prevQuarterActualsRevenue: null,
    prevQuarterActualsRevenueNet: null,
    prevQuarterActualsRevenueTNet: null,
    prevQuarterActualsRevenueUTNet: null,
    prevQuarterEstimatedActualsRevenue: null,
    prevQuarterEstimatedActualsRevenueNet: null,
    prevQuarterEstimatedActualsRevenueTNet: null,
    prevQuarterEstimatedActualsRevenueUTNet: null,
    prevQuarterSobActuals: null,
    prevQuarterSobActualsNet: null,
    prevQuarterSobActualsTNet: null,
    prevQuarterSobActualsUTNet: null,

    currQuarterActualsRevenue: null,
    currQuarterActualsRevenueNet: null,
    currQuarterActualsRevenueTNet: null,
    currQuarterActualsRevenueUTNet: null,
    currQuarterEstimatedActualsRevenue: null,
    currQuarterEstimatedActualsRevenueNet: null,
    currQuarterEstimatedActualsRevenueTNet: null,
    currQuarterEstimatedActualsRevenueUTNet: null,
    currQuarterSobActuals: null,
    currQuarterSobActualsNet: null,
    currQuarterSobActualsTNet: null,
    currQuarterSobActualsUTNet: null,

    yoyRevenue: item.yoyRevenue,
    yoyRevenueNet: item.yoyRevenueNet,
    yoyRevenueTNet: item.yoyRevenueTNet,
    yoyRevenueUTNet: item.yoyRevenueUTNet,
    yoyBaseline: item.yoyBaseline,
    yoyBaselineNet: item.yoyBaselineNet,
    yoyBaselineTNet: item.yoyBaselineTNet,
    yoyBaselineUTNet: item.yoyBaselineUTNet,
    currYearQoQ: item.currYearQoQ,
    currYearQoQNet: item.currYearQoQNet,
    currYearQoQTNet: item.currYearQoQTNet,
    currYearQoQUTNet: item.currYearQoQUTNet,
    partnerTamYoY: item.partnerTamYoY,
    partnerTamYoYNet: item.partnerTamYoYNet,
    partnerTamYoYTNet: item.partnerTamYoYTNet,
    partnerTamYoYUTNet: item.partnerTamYoYUTNet,
    partnerTamActualsYoY: item.partnerTamActualsYoY,
    partnerTamActualsYoYNet: item.partnerTamActualsYoYNet,
    partnerTamActualsYoYTNet: item.partnerTamActualsYoYTNet,
    partnerTamActualsYoYUTNet: item.partnerTamActualsYoYUTNet,

    coverageWW: item.coverageWW,
    coverageWWNet: item.coverageWWNet,
    coverageWWTNet: item.coverageWWTNet,
    coverageWWUTNet: item.coverageWWUTNet,
    coverageMarket: item.coverageMarket,
    coverageMarketNet: item.coverageMarketNet,
    coverageMarketTNet: item.coverageMarketTNet,
    coverageMarketUTNet: item.coverageMarketUTNet,

    currYearActualsRevenue: item.currYearActualsRevenue,
    currYearActualsRevenueNet: item.currYearActualsRevenueNet,
    currYearActualsRevenueTNet: item.currYearActualsRevenueTNet,
    currYearActualsRevenueUTNet: item.currYearActualsRevenueUTNet,
    currYearEstimatedActualsRevenue: item.currYearEstimatedActualsRevenue,
    currYearEstimatedActualsRevenueNet: item.currYearEstimatedActualsRevenueNet,
    currYearEstimatedActualsRevenueTNet: item.currYearEstimatedActualsRevenueTNet,
    currYearEstimatedActualsRevenueUTNet: item.currYearEstimatedActualsRevenueUTNet,
    currYearSobActual: item.currYearSobActual,
    currYearSobActualNet: item.currYearSobActualNet,
    currYearSobActualTNet: item.currYearSobActualTNet,
    currYearSobActualUTNet: item.currYearSobActualUTNet,
    currYearPlansRevenue: item.currYearPlansRevenue,
    currYearPlansRevenueNet: item.currYearPlansRevenueNet,
    currYearPlansRevenueTNet: item.currYearPlansRevenueTNet,
    currYearPlansRevenueUTNet: item.currYearPlansRevenueUTNet,
    currYearEstimatedPlansRevenue: item.currYearEstimatedPlansRevenue,
    currYearEstimatedPlansRevenueNet: item.currYearEstimatedPlansRevenueNet,
    currYearEstimatedPlansRevenueTNet: item.currYearEstimatedPlansRevenueTNet,
    currYearEstimatedPlansRevenueUTNet: item.currYearEstimatedPlansRevenueUTNet,
    currYearSobPlan: item.currYearSobPlan,
    currYearSobPlanNet: item.currYearSobPlanNet,
    currYearSobPlanTNet: item.currYearSobPlanTNet,
    currYearSobPlanUTNet: item.currYearSobPlanUTNet,
    currYearSalesPerformance: item.currYearSalesPerformance,
    currYearSalesPerformanceNet: item.currYearSalesPerformanceNet,
    currYearSalesPerformanceTNet: item.currYearSalesPerformanceTNet,
    currYearSalesPerformanceUTNet: item.currYearSalesPerformanceUTNet,
    currYearYoYGrowth: item.currYearYoYGrowth,
    currYearYoYGrowthNet: item.currYearYoYGrowthNet,
    currYearYoYGrowthTNet: item.currYearYoYGrowthTNet,
    currYearYoYGrowthUTNet: item.currYearYoYGrowthUTNet,
    currYearQuarterTamPlan: item.currYearQuarterTamPlan,
    currYearQuarterTamPlanNet: item.currYearQuarterTamPlanNet,
    currYearQuarterTamPlanTNet: item.currYearQuarterTamPlanTNet,
    currYearQuarterTamPlanUTNet: item.currYearQuarterTamPlanUTNet,
    currYearQuarterTamActuals: item.currYearQuarterTamActuals,
    currYearQuarterTamActualsNet: item.currYearQuarterTamActualsNet,
    currYearQuarterTamActualsTNet: item.currYearQuarterTamActualsTNet,
    currYearQuarterTamActualsUTNet: item.currYearQuarterTamActualsUTNet,

    currYearExpExitRevenue: item.currYearExpExitRevenue ?? null,
    currYearExpExitRevenueNet: item.currYearExpExitRevenueNet ?? null,
    currYearExpExitRevenueTNet: item.currYearExpExitRevenueTNet ?? null,
    currYearExpExitRevenueUTNet: item.currYearExpExitRevenueUTNet ?? null,
    currYearEstimatedExpExitRevenue: item.currYearEstimatedExpExitRevenue ?? null,
    currYearEstimatedExpExitRevenueNet: item.currYearEstimatedExpExitRevenueNet ?? null,
    currYearEstimatedExpExitRevenueTNet: item.currYearEstimatedExpExitRevenueTNet ?? null,
    currYearEstimatedExpExitRevenueUTNet: item.currYearEstimatedExpExitRevenueUTNet ?? null,
    currYearSobExpExit: item.currYearSobExpExit ?? null,
    currYearSobExpExitNet: item.currYearSobExpExitNet ?? null,
    currYearSobExpExitTNet: item.currYearSobExpExitTNet ?? null,
    currYearSobExpExitUTNet: item.currYearSobExpExitUTNet ?? null,
    expExitYoYPP: item.expExitYoYPP ?? null,
    expExitYoYPPNet: item.expExitYoYPPNet ?? null,
    expExitYoYPPTNet: item.expExitYoYPPTNet ?? null,
    expExitYoYPPUTNet: item.expExitYoYPPUTNet ?? null,
    expExitQoQ: item.expExitQoQ ?? null,
    expExitQoQNet: item.expExitQoQNet ?? null,
    expExitQoQTNet: item.expExitQoQTNet ?? null,
    expExitQoQUTNet: item.expExitQoQUTNet ?? null,
    expExitVsPlan: item.expExitVsPlan ?? null,
    expExitVsPlanNet: item.expExitVsPlanNet ?? null,
    expExitVsPlanTNet: item.expExitVsPlanTNet ?? null,
    expExitVsPlanUTNet: item.expExitVsPlanUTNet ?? null,
    expExitSalesPerformance: item.expExitSalesPerformance ?? null,
    expExitSalesPerformanceNet: item.expExitSalesPerformanceNet ?? null,
    expExitSalesPerformanceTNet: item.expExitSalesPerformanceTNet ?? null,
    expExitSalesPerformanceUTNet: item.expExitSalesPerformanceUTNet ?? null,
    expExitYoYGrowth: item.expExitYoYGrowth ?? null,
    expExitYoYGrowthNet: item.expExitYoYGrowthNet ?? null,
    expExitYoYGrowthTNet: item.expExitYoYGrowthTNet ?? null,
    expExitYoYGrowthUTNet: item.expExitYoYGrowthUTNet ?? null,
    currYearQuarterTamExpExit: item.currYearQuarterTamExpExit ?? null,
    currYearQuarterTamExpExitNet: item.currYearQuarterTamExpExitNet ?? null,
    currYearQuarterTamExpExitTNet: item.currYearQuarterTamExpExitTNet ?? null,
    currYearQuarterTamExpExitUTNet: item.currYearQuarterTamExpExitUTNet ?? null,
    partnerTamExpExitYoY: item.partnerTamExpExitYoY ?? null,
    partnerTamExpExitYoYNet: item.partnerTamExpExitYoYNet ?? null,
    partnerTamExpExitYoYTNet: item.partnerTamExpExitYoYTNet ?? null,
    partnerTamExpExitYoYUTNet: item.partnerTamExpExitYoYUTNet ?? null,
  }))
}
